var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @file MultiTreeSelect组件
 * @author (wangzichuan)
 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import _ from 'lodash-es';

import Search from '../../Search';
import Tree from '../../Tree';
import MultiSelectInputItem from './MultiSelectInputItem.js';
import PopperWrap from '../../PopperWrap';
import { classPrefix, EleResize } from '../../../common/util';
/* global getComputedStyle */
import './MultiTreeSelect.less';

/**
 * 参数说明
 * className               可选，自定义class
 * classPrefix             可选，自定义前缀
 * width                   可选，自定义宽度
 * disabled                可选，disabled状态
 * placeHolder             可选，无数据的显示文本
 * treeProps               必须，参考tree的属性
 * showSearch              可选，是否显示搜索功能
 * cancelIcon              可选，是否显示清空icon
 * getValue                可选，选项变化的回调函数
 * control                 可选，是否为可控组件
 * onSearch                可选，搜索框的回调函数
 * zIndex                  可选，下拉层的zIndex
 * preventOverflowEnabled     非必需,下拉是否受overflow碰撞影响
 * popupOnBody             可选,下拉是否挂在body上
 */

var MultiTreeSelect = function (_Component) {
    _inherits(MultiTreeSelect, _Component);

    function MultiTreeSelect(props) {
        _classCallCheck(this, MultiTreeSelect);

        var _this = _possibleConstructorReturn(this, (MultiTreeSelect.__proto__ || Object.getPrototypeOf(MultiTreeSelect)).call(this, props));

        _initialiseProps.call(_this);

        var treeProps = props.treeProps;
        var defaultCheckedKeys = treeProps.defaultCheckedKeys,
            optionData = treeProps.optionData;


        _this.state = {
            defaultCheckedKeys: defaultCheckedKeys || [],
            optionData: optionData || [],
            isShowPanel: false,
            iconOnHover: false,
            inputFocus: false,
            searchValue: '',
            inputWidth: 120
        };

        _this.checkboxArr = _this.iteratorCheckboxArr(optionData, props);
        _this.checkboxArr = _this.formateCheckboxArr(_this.checkboxArr);
        _this.oldSelectArr = null;
        _this.selectArr = defaultCheckedKeys || [];

        _this.FORM_NEED_VALIDATE = 0;
        _this.FORM_NO_NEED_VALIDATE = 1;
        _this.formCallback(defaultCheckedKeys, _this.FORM_NO_NEED_VALIDATE);
        return _this;
    }

    _createClass(MultiTreeSelect, [{
        key: 'UNSAFE_componentWillReceiveProps',
        value: function UNSAFE_componentWillReceiveProps(np) {
            var treeProps = np.treeProps;
            var defaultCheckedKeys = treeProps.defaultCheckedKeys,
                optionData = treeProps.optionData;

            var newOptionData = optionData;
            this.setState({
                defaultCheckedKeys: defaultCheckedKeys || [],
                optionData: newOptionData
            });
            this.initCheckboxArr(np);
            if (!_.isEqual(treeProps.defaultCheckedKeys, this.props.treeProps.defaultCheckedKeys)) {
                this.formCallback(defaultCheckedKeys, this.FORM_NEED_VALIDATE);
                this.PopperWrap.update(); // 更新下拉位置
            }
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            if (!this.props.responsive) {
                return;
            }
            this.resizeHandler();
            EleResize.on(this.tsContainer, this.resizeHandler);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this.formCallback(this.props.treeProps.defaultCheckedKeys, this.FORM_NO_NEED_VALIDATE, true);

            if (!this.props.responsive) {
                return;
            }
            EleResize.off(this.tsContainer, this.resizeHandler);
        }
    }, {
        key: 'initInputValue',
        value: function initInputValue(data, current) {
            var obj = this.iteratorFindObj(data, current);
            if (obj) {
                return obj.title;
            } else {
                return '';
            }
        }
    }, {
        key: 'iteratorFindObj',
        value: function iteratorFindObj(data, current) {
            if (!data || !current) {
                return null;
            }
            for (var i = 0; i < data.length; i++) {
                if (data[i][this.props.treeProps.uniqueKeyName || 'id'] === current) {
                    return data[i];
                } else if (data[i].children) {
                    var objChild = this.iteratorFindObj(data[i].children, current);
                    if (objChild) {
                        return objChild;
                    }
                }
            }
            return null;
        }
    }, {
        key: 'iteratorFindFatherObj',
        value: function iteratorFindFatherObj(data, current) {
            var father = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

            if (!data || !current) {
                return null;
            }
            for (var i = 0; i < data.length; i++) {
                if (data[i][this.props.treeProps.uniqueKeyName || 'id'] === current) {
                    return father;
                } else if (data[i].children) {
                    var objChild = this.iteratorFindFatherObj(data[i].children, current, data[i]);
                    if (objChild) {
                        return objChild;
                    }
                }
            }
            return null;
        }
    }, {
        key: 'filterOptionDataOfNull',
        value: function filterOptionDataOfNull(arr) {
            return arr.filter(function (item) {
                return item;
            });
        }
    }, {
        key: 'addDefaultCheckedKeys',
        value: function addDefaultCheckedKeys(_ref) {
            var current = _ref.current;

            this.checkboxHandle({ current: current });
            return this.selectArr;
        }
    }, {
        key: 'initCheckboxArr',
        value: function initCheckboxArr(props) {
            this.checkboxArr = this.iteratorCheckboxArr(props.treeProps.optionData || [], props);
            this.checkboxArr = this.formateCheckboxArr(this.checkboxArr);
        }

        // 将数据添加上checked状态

    }, {
        key: 'iteratorCheckboxArr',
        value: function iteratorCheckboxArr(data, props) {
            var _this2 = this;

            if (data === undefined || data.length === 0) {
                return;
            }
            var treeProps = props.treeProps;
            var defaultCheckedKeys = treeProps.defaultCheckedKeys || [];
            var defaultDisabledKeys = treeProps.defaultDisabledKeys || [];
            var defaultSelectedKey = treeProps.defaultSelectedKey || [];
            var uniqueKeyName = treeProps.uniqueKeyName || 'id';
            return data.map(function (rowData) {
                var newRowData = _.cloneDeep(rowData);
                newRowData.checked = defaultCheckedKeys.indexOf(rowData[uniqueKeyName]) !== -1;
                newRowData.disabled = defaultDisabledKeys.indexOf(rowData[uniqueKeyName]) !== -1;
                newRowData.selected = defaultSelectedKey === newRowData[uniqueKeyName];
                if (_.hasIn(newRowData, 'children')) {
                    newRowData.children = _this2.iteratorCheckboxArr(newRowData.children, props);
                }
                return newRowData;
            });
        }

        // 根据子数据checked状态，决定自身checked状态

    }, {
        key: 'formateCheckboxArr',
        value: function formateCheckboxArr(data) {
            var _this3 = this;

            if (data === undefined || data.length === 0) {
                return [];
            }
            return data.map(function (rowData) {
                var newRowData = _.cloneDeep(rowData);
                if (_.hasIn(newRowData, 'children')) {
                    newRowData.children = _this3.formateCheckboxArr(newRowData.children);
                    var count = 0;
                    newRowData.children.forEach(function (i) {
                        if (i.checked) {
                            count++;
                        }
                    });
                    switch (count) {
                        case 0:
                            // 取消选择
                            newRowData.checked = false;
                            break;
                        case newRowData.children.length:
                            // 全选
                            newRowData.checked = true;
                            break;
                        default:
                            // 部分选择
                            newRowData.checked = -1;
                            break;
                    }
                }
                return newRowData;
            });
        }
    }, {
        key: 'formateOutputData',
        value: function formateOutputData(_ref2) {
            var checkboxArr = _ref2.checkboxArr;

            this.getSelectArr(checkboxArr, true);
            // 保持已选择数据顺序的前提下，在尾部添加新元素
            this.selectArr = _.union(_.intersection(this.oldSelectArr, this.selectArr), this.selectArr);
        }

        // 判断子数据是否全选（不计算diabled态）

    }, {
        key: 'isChildrenAllSelect',
        value: function isChildrenAllSelect(children) {
            for (var i = 0; i < children.length; i++) {
                var nowChild = children[i];
                if (!nowChild.checked && !nowChild.disabled) {
                    return false;
                }
                if (_.hasIn(nowChild, 'children') && !this.isChildrenAllSelect(nowChild.children)) {
                    return false;
                }
            }
            return true;
        }

        // 将数据中选择项存入this.selectArr

    }, {
        key: 'getSelectArr',
        value: function getSelectArr(data, first) {
            var _this4 = this;

            if (first) {
                this.oldSelectArr = this.selectArr;
                this.selectArr = [];
            }
            data.map(function (i) {
                i.checked === true && _this4.selectArr.push(i[_this4.props.treeProps.uniqueKeyName || 'id']);
                i.children && _this4.getSelectArr(i.children);
            });
        }

        // 根据本节点决定子节点checked状态

    }, {
        key: 'checkboxChangeChildren',
        value: function checkboxChangeChildren(data, bool) {
            var _this5 = this;

            return data.map(function (i) {
                var newI = _.cloneDeep(i);
                if (newI.disabled) {
                    return newI;
                }
                newI.checked = bool;
                if (_.hasIn(newI, 'children')) {
                    newI.children = _this5.checkboxChangeChildren(newI.children, bool);
                }
                return newI;
            });
        }
    }, {
        key: 'filterFather',
        value: function filterFather(defaultCheckedKeys) {
            var _this6 = this;

            return defaultCheckedKeys.filter(function (item) {
                var fatherObj = _this6.iteratorFindFatherObj(_this6.checkboxArr, item);
                if (fatherObj) {
                    if (fatherObj.checked === true) {
                        return false;
                    }
                }
                return true;
            });
        }
    }, {
        key: 'filterDefaultCheckedKeys',
        value: function filterDefaultCheckedKeys(_ref3) {
            var _this7 = this;

            var cancelItem = _ref3.cancelItem;

            return this.state.defaultCheckedKeys.filter(function (item) {
                var obj = _this7.iteratorFindObj(_this7.props.treeProps.optionData, item);
                var currentObj = _this7.iteratorFindObj(_this7.props.treeProps.optionData, cancelItem);
                if (currentObj.children) {
                    if (_this7.isChildren(currentObj.children, item)) {
                        return false;
                    }
                }
                if (obj.children) {
                    if (_this7.isChildren(obj.children, cancelItem)) {
                        return false;
                    }
                }
                if (item === cancelItem) {
                    return false;
                }
                return true;
            });
        }
    }, {
        key: 'isChildren',
        value: function isChildren(data, current) {
            var uniqueKeyName = this.props.treeProps.uniqueKeyName || 'id';
            for (var i = 0; i < data.length; i++) {
                if (data[i][uniqueKeyName] === current) {
                    return true;
                } else if (data[i].children) {
                    if (this.isChildren(data[i].children, current)) {
                        return true;
                    }
                }
            }
            return false;
        }
    }, {
        key: 'searchInputFocus',
        value: function searchInputFocus() {
            var searchInput = this.searchWrapper.querySelector('input');
            searchInput.focus();
        }
    }, {
        key: 'render',
        value: function render() {
            var _classnames,
                _this8 = this,
                _classnames2;

            var _props = this.props,
                className = _props.className,
                classPrefix = _props.classPrefix,
                width = _props.width,
                disabled = _props.disabled,
                treeProps = _props.treeProps,
                cancelIcon = _props.cancelIcon,
                showSearch = _props.showSearch,
                label = _props.label,
                tips = _props.tips,
                noWarning = _props.noWarning,
                validate = _props.validate,
                zIndex = _props.zIndex,
                preventOverflowEnabled = _props.preventOverflowEnabled,
                popupOnBody = _props.popupOnBody,
                responsive = _props.responsive,
                searchClear = _props.searchClear;


            var realWidth = responsive ? this.state.inputWidth : width;

            var rootCls = classnames((_classnames = {}, _defineProperty(_classnames, classPrefix + '-single-tree-select-wrap', true), _defineProperty(_classnames, className, !!className), _defineProperty(_classnames, 'margin-bottom-24', !noWarning), _defineProperty(_classnames, 'responsive', responsive), _classnames));
            var inputCls = classnames({
                'tree-select-multi-input': true,
                'tree-select-multi-focus': this.state.isShowPanel || this.state.inputFocus
            });
            var myTreeProps = _extends({}, treeProps, {
                optionData: this.state.optionData,
                control: true,
                inSelect: true,
                width: realWidth,
                checkable: true,
                defaultCheckedKeys: this.state.defaultCheckedKeys,
                // onCheck: this.treeOnCheck,
                onSelect: this.treeOnCheck,
                titleCheckbox: true
            });
            var hasWarning = -1;
            var containerCls = classnames({
                'input-container': true,
                'tree-select-multi-diabled': disabled,
                'warning-border': !noWarning && validate && validate.ret === hasWarning
            });
            var containerStyle = {
                width: responsive ? '100%' : width
            };
            var hasCancelIcon = cancelIcon && this.state.iconOnHover && this.state.defaultCheckedKeys.length !== 0;
            var iconCls = classnames({
                'tree-select-icon': true,
                'tree-select-icon-active': !hasCancelIcon && this.state.isShowPanel,
                'tree-select-cancel-icon': hasCancelIcon
            });
            var leftAndRightPadding = 20;
            var searchHight = 32;
            var searchProps = {
                value: this.state.searchValue,
                name: 'treeSelectSearch',
                placeHolder: '请输入搜索内容',
                noDistance: true,
                height: searchHight,
                width: parseFloat(realWidth) - leftAndRightPadding,
                getValue: this.searchChange,
                cancelIcon: searchClear
            };
            return React.createElement(
                'div',
                { className: rootCls },
                label && React.createElement(
                    'div',
                    { className: classPrefix + '-form-label' },
                    label
                ),
                React.createElement(PopperWrap, {
                    ref: function ref(el) {
                        _this8.PopperWrap = el;
                    },
                    containerNode: React.createElement(
                        'div',
                        {
                            className: containerCls,
                            ref: function ref(el) {
                                _this8.tsContainer = el;
                            },
                            style: containerStyle
                        },
                        React.createElement(
                            'ul',
                            { className: inputCls, tabIndex: '-1', onClick: this.inputOnClick },
                            this.renderMultiItems()
                        ),
                        React.createElement('div', {
                            className: iconCls,
                            onClick: this.iconOnClick,
                            onMouseEnter: this.iconOnHover,
                            onMouseLeave: this.iconOnHover
                        }),
                        !noWarning && React.createElement(
                            'div',
                            { className: classPrefix + '-form-warning' },
                            validate && validate.message ? React.createElement(
                                'div',
                                null,
                                React.createElement('i', { className: classPrefix + '-form-error' }),
                                validate.message
                            ) : ''
                        )
                    ),
                    popupNode: React.createElement(
                        'div',
                        null,
                        showSearch && React.createElement(
                            'div',
                            {
                                className: 'tree-select-search',
                                ref: function ref(el) {
                                    _this8.searchWrapper = el;
                                }
                            },
                            React.createElement(Search, searchProps)
                        ),
                        React.createElement(Tree, myTreeProps)
                    ),
                    popupNodeWidth: parseFloat(realWidth),
                    popupNodeClassName: classnames((_classnames2 = {}, _defineProperty(_classnames2, classPrefix + '-tree-select-panel', true), _defineProperty(_classnames2, 'no-padding-top-bottom', showSearch), _classnames2)),
                    isShowPopup: this.state.isShowPanel,
                    onBodyClick: this.bodyClick,
                    popupNodeZIndex: zIndex,
                    preventOverflowEnabled: preventOverflowEnabled,
                    popupOnBody: popupOnBody
                }),
                tips && React.createElement(
                    'div',
                    { className: classPrefix + '-form-tips' },
                    tips
                )
            );
        }
    }]);

    return MultiTreeSelect;
}(Component);

MultiTreeSelect.propTypes = {
    className: PropTypes.string,
    classPrefix: PropTypes.string,
    width: PropTypes.number,
    multiple: PropTypes.bool,
    disabled: PropTypes.bool,
    placeHolder: PropTypes.string,
    treeProps: PropTypes.object,
    showSearch: PropTypes.bool,
    cancelIcon: PropTypes.bool,
    getValue: PropTypes.func,
    control: PropTypes.bool,
    onSearch: PropTypes.func,
    formFlag: PropTypes.bool,
    name: PropTypes.string,
    increment: PropTypes.string,
    onHandleChange: PropTypes.func,
    label: PropTypes.node,
    tips: PropTypes.node,
    noWarning: PropTypes.bool,
    validate: PropTypes.object,
    zIndex: PropTypes.number,
    preventOverflowEnabled: PropTypes.bool,
    popupOnBody: PropTypes.bool,
    responsive: PropTypes.bool,
    searchClear: PropTypes.bool
};
MultiTreeSelect.defaultProps = {
    classPrefix: classPrefix,
    width: 120,
    placeHolder: '请选择',
    preventOverflowEnabled: true,
    searchClear: true
};

var _initialiseProps = function _initialiseProps() {
    var _this9 = this;

    this.resizeHandler = function () {
        var width = getComputedStyle(_this9.tsContainer).width;
        _this9.setState({
            inputWidth: parseFloat(width)
        });
    };

    this.formCallback = function (data, type, isDelete) {
        var _props2 = _this9.props,
            formFlag = _props2.formFlag,
            name = _props2.name,
            increment = _props2.increment,
            onHandleChange = _props2.onHandleChange;


        if (onHandleChange && formFlag && _.isFunction(onHandleChange)) {
            onHandleChange({
                name: name,
                value: data
            }, _this9, type, increment, isDelete);
        }
    };

    this.bodyClick = function () {
        _this9.setState({
            isShowPanel: false,
            inputFocus: false,
            searchValue: ''
        }, _this9.isShowPanelOnChange);
    };

    this.inputOnClick = function () {
        if (_this9.props.disabled) {
            return;
        }
        _this9.setState({
            isShowPanel: !_this9.state.isShowPanel,
            inputFocus: true,
            searchValue: ''
        }, _this9.isShowPanelOnChange);
    };

    this.treeOnSelect = function (_ref4) {
        var current = _ref4.current,
            position = _ref4.position;

        _this9.onSelectChange({ current: current, position: position });
        _this9.setState({
            isShowPanel: false
        }, _this9.isShowPanelOnChange);
    };

    this.iconOnClick = function (e) {
        if (_this9.props.disabled) {
            return;
        }
        var hasCancelIcon = _this9.props.cancelIcon && _this9.state.iconOnHover && _this9.state.defaultCheckedKeys.length !== 0;
        if (hasCancelIcon) {
            _this9.onCheckchange({ checkedKeys: [] });
        } else {
            var input = e.target.parentNode.querySelector('.tree-select-multi-input');
            input.focus();
            _this9.setState({ isShowPanel: !_this9.state.isShowPanel }, _this9.isShowPanelOnChange);
        }
    };

    this.iconOnHover = function (e) {
        if (_this9.props.disabled) {
            return;
        }
        if (e.type === 'mouseenter') {
            _this9.setState({ iconOnHover: true });
        } else if (e.type === 'mouseleave') {
            _this9.setState({ iconOnHover: false });
        }
    };

    this.searchChange = function (e) {
        var _props3 = _this9.props,
            onSearch = _props3.onSearch,
            treeProps = _props3.treeProps;

        var newOptionData = treeProps.optionData;
        if (e.value) {
            newOptionData = _this9.filterOptionData(e.value, treeProps.optionData);
        }
        _this9.setState({
            optionData: newOptionData,
            searchValue: e.value
        }, function () {
            _.isFunction(onSearch) && onSearch(e);
        });
    };

    this.filterOptionData = function (value, data) {
        var optionData = data.map(function (itemT) {
            var item = _.cloneDeep(itemT);
            if (item.title.indexOf(value) !== -1) {
                if (item.children) {
                    item.children = _this9.filterOptionData(value, item.children);
                }
                return item;
            } else if (item.children) {
                item.children = _this9.filterOptionData(value, item.children);
                if (item.children.length !== 0) {
                    return item;
                }
            }
            return null;
        });
        return _this9.filterOptionDataOfNull(optionData);
    };

    this.isShowPanelOnChange = function () {
        var _props4 = _this9.props,
            treeProps = _props4.treeProps,
            showSearch = _props4.showSearch;

        _this9.setState({
            optionData: treeProps.optionData
        });

        if (_this9.state.isShowPanel && showSearch) {
            _this9.searchInputFocus(); // 自动获得焦点
        }

        if (_this9.state.isShowPanel) {
            _this9.PopperWrap.update(); // 每次点开下来就重新计算下拉位置
        }
    };

    this.treeOnCheck = function (_ref5) {
        var position = _ref5.position;

        var current = position[position.length - 1];
        var treeProps = _this9.props.treeProps;
        var defaultCheckedKeys = treeProps.defaultCheckedKeys;
        var checkedKeys = void 0;
        if (defaultCheckedKeys.indexOf(current) === -1) {
            checkedKeys = _this9.addDefaultCheckedKeys({ current: current });
        } else {
            checkedKeys = _this9.filterDefaultCheckedKeys({ cancelItem: current });
        }
        _this9.setState({ searchValue: '' }, _this9.isShowPanelOnChange);
        _this9.onCheckchange({ checkedKeys: checkedKeys });
    };

    this.checkboxHandle = function (_ref6) {
        var current = _ref6.current;

        var newArr = _.cloneDeep(_this9.checkboxArr);
        var obj = _this9.iteratorFindObj(newArr, current);
        obj.checked = obj.checked !== true;
        if (_.hasIn(obj, 'children')) {
            // 保证含有disabled部分全选子节点，点击后可取消全选
            obj.checked = !_this9.isChildrenAllSelect(obj.children);
            obj.children = _this9.checkboxChangeChildren(obj.children, obj.checked);
        }
        var checkboxArr = _this9.formateCheckboxArr(newArr);

        _this9.formateOutputData({ checkboxArr: checkboxArr });
    };

    this.onCheckchange = function (_ref7) {
        var checkedKeys = _ref7.checkedKeys;
        var _props5 = _this9.props,
            getValue = _props5.getValue,
            name = _props5.name;

        _.isFunction(getValue) && getValue({
            name: name,
            value: checkedKeys
        });
    };

    this.renderMultiItems = function () {
        if (_this9.state.defaultCheckedKeys.length === 0) {
            return React.createElement(
                'div',
                { className: 'input-placehoder' },
                _this9.props.placeHolder
            );
        } else {
            var defaultCheckedKeys = _this9.filterFather(_this9.state.defaultCheckedKeys);
            return defaultCheckedKeys.map(function (item) {
                var itemObj = _this9.iteratorFindObj(_this9.props.treeProps.optionData, item);
                if (!itemObj) {
                    return undefined;
                }
                var uniqueKeyName = _this9.props.treeProps.uniqueKeyName || 'id';
                return React.createElement(MultiSelectInputItem, {
                    itemObj: itemObj,
                    key: itemObj[uniqueKeyName],
                    cancelOnClick: _this9.cancelOnClick
                });
            });
        }
    };

    this.cancelOnClick = function (e) {
        if (_this9.props.disabled) {
            return;
        }
        var uniqueKeyName = _this9.props.treeProps.uniqueKeyName || 'id';
        var cancelItem = e[uniqueKeyName];
        var defaultCheckedKeys = _this9.filterDefaultCheckedKeys({ cancelItem: cancelItem });
        _this9.onCheckchange({ checkedKeys: defaultCheckedKeys });
        if (_this9.props.control) {
            return;
        }
        _this9.setState({ defaultCheckedKeys: defaultCheckedKeys });
    };
};

export default MultiTreeSelect;